import React, { useState, useRef } from "react";
import { Formik, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import { Verify } from "./Verify";
import { registerApi } from "../../../api";
import { withRouter } from "react-router-dom";
import { Alert, ModalComp } from "../../../shared";
import { PrivacyPolicy, TermsAndConditions } from "../../";
import { useTranslation } from "react-i18next";
import "../Login/LoginFlat.css";
import { ThemeLanguageToggle } from "../Login/ThemeLanguageToggle";

const RegisterComp = (props) => {
  const { t, i18n } = useTranslation();
  const [TermsChecked, setTermsChecked] = useState(false);
  const [PrivecyChecked, setPrivecyChecked] = useState(false);
  const [openTermsModal, setOpenTermsModal] = useState(false);
  const toggleTerms = () => setOpenTermsModal(!openTermsModal);
  const [openPrivacyModal, setOpenPrivacyModal] = useState(false);
  const togglePrivacy = () => setOpenPrivacyModal(!openPrivacyModal);
  const [verify, setVerify] = useState(false);
  const form = useRef(null);
  const [showAlert, setShowAlert] = useState({
    show: false,
    message: "",
    type: "",
  });

  const initialLoginValues = {
    name: "",
    mobile: "",
    email: "",
    password: "",
  };

  const submitLoginForm = () => {
    const data = new FormData(form.current);
    registerApi(data)
      .then((res) => {
        props.history.push("/login");
      })
      .catch(() => {
        setShowAlert((prevState) => ({
          ...prevState,
          show: true,
          message: t("این کاربر قبلا ثبت شده است."),
          type: "Error",
        }));
        setTimeout(() => {
          setShowAlert((prevState) => ({
            ...prevState,
            show: false,
          }));
        }, 5000);
      });
  };

  const validationSchemaLogin = Yup.object({
    name: Yup.string().required(() => t("نام و نام خانوادگی را وارد کنید")),
    mobile: Yup.string().required(t("شماره موبایل را وارد کنید")),
    email: Yup.string()
      .required(t("ایمیل را وارد کنید"))
      .email("ایمیل را طبق فرمت وارد کنید."),
    password: Yup.string()
      .required(t("رمز عبور را وارد کنید."))
      .min(3, t("رمز عبور حداقل باید 3 حرف باشد")),
  });

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  return (
    <div className="login-flat-container">
      {/* Theme and Language Controls */}
      <ThemeLanguageToggle />
      
      <ModalComp
        modal={openTermsModal}
        toggle={toggleTerms}
        component={<TermsAndConditions />}
      />
      <ModalComp
        modal={openPrivacyModal}
        toggle={togglePrivacy}
        component={<PrivacyPolicy />}
      />
      <div className="login-flat-card">
        {!verify ? (
          <>
            {/* Header Section */}
            <div className="login-flat-header">
              <div className="login-flat-icon-wrapper">
                <svg className="login-flat-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M15 12C17.21 12 19 10.21 19 8C19 5.79 17.21 4 15 4C12.79 4 11 5.79 11 8C11 10.21 12.79 12 15 12ZM6 10V7H4V10H1V12H4V15H6V12H9V10H6ZM15 14C12.33 14 7 15.34 7 18V20H23V18C23 15.34 17.67 14 15 14Z" fill="currentColor"/>
                </svg>
              </div>
              <h2 className="login-flat-title">{t("ثبت نام")}</h2>
              <p className="login-flat-subtitle">{t("دسترسی به حساب")}</p>
            </div>
            
            {/* Form Section */}
            <div className="login-flat-form">
              <Formik
                initialValues={initialLoginValues}
                onSubmit={submitLoginForm}
                validationSchema={validationSchemaLogin}
              >
                {(props) => (
                  <Form ref={form}>
                    {/* Name Input */}
                    <div className="login-flat-input-group">
                      <div className="login-flat-input-icon">
                        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M12 12C14.21 12 16 10.21 16 8C16 5.79 14.21 4 12 4C9.79 4 8 5.79 8 8C8 10.21 9.79 12 12 12ZM12 14C9.33 14 4 15.34 4 18V20H20V18C20 15.34 14.67 14 12 14Z" fill="currentColor"/>
                        </svg>
                      </div>
                      <input
                        type="text"
                        placeholder={t("نام و نام خانوادگی")}
                        name="name"
                        className="login-flat-input"
                        onChange={props.handleChange}
                        onBlur={props.handleBlur}
                      />
                      <ErrorMessage name="name">
                        {(errMsg) => (
                          <div className="login-flat-error">{errMsg}</div>
                        )}
                      </ErrorMessage>
                    </div>
                    
                    {/* Mobile Input */}
                    <div className="login-flat-input-group">
                      <div className="login-flat-input-icon">
                        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M17 1.01L7 1C5.9 1 5 1.9 5 3V21C5 22.1 5.9 23 7 23H17C18.1 23 19 22.1 19 21V3C19 1.9 18.1 1.01 17 1.01ZM17 19H7V5H17V19Z" fill="currentColor"/>
                        </svg>
                      </div>
                      <input
                        type="number"
                        placeholder={t("شماره موبایل")}
                        name="mobile"
                        className="login-flat-input"
                        onChange={props.handleChange}
                        onBlur={props.handleBlur}
                      />
                      <ErrorMessage name="mobile">
                        {(errMsg) => (
                          <div className="login-flat-error">{errMsg}</div>
                        )}
                      </ErrorMessage>
                    </div>
                    
                    {/* Email Input */}
                    <div className="login-flat-input-group">
                      <div className="login-flat-input-icon">
                        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M20 4H4C2.9 4 2.01 4.9 2.01 6L2 18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6C22 4.9 21.1 4 20 4ZM20 8L12 13L4 8V6L12 11L20 6V8Z" fill="currentColor"/>
                        </svg>
                      </div>
                      <input
                        type="email"
                        placeholder={t("ایمیل")}
                        name="email"
                        className="login-flat-input"
                        onChange={props.handleChange}
                        onBlur={props.handleBlur}
                      />
                      <ErrorMessage name="email">
                        {(errMsg) => (
                          <div className="login-flat-error">{errMsg}</div>
                        )}
                      </ErrorMessage>
                    </div>
                    
                    {/* Password Input */}
                    <div className="login-flat-input-group">
                      <div className="login-flat-input-icon">
                        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M18 8H17V6C17 3.24 14.76 1 12 1C9.24 1 7 3.24 7 6V8H6C4.9 8 4 8.9 4 10V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V10C20 8.9 19.1 8 18 8ZM12 17C10.9 17 10 16.1 10 15C10 13.9 10.9 13 12 13C13.1 13 14 13.9 14 15C14 16.1 13.1 17 12 17ZM15.1 8H8.9V6C8.9 4.29 10.29 2.9 12 2.9C13.71 2.9 15.1 4.29 15.1 6V8Z" fill="currentColor"/>
                        </svg>
                      </div>
                      <input
                        type="password"
                        placeholder={t("رمز عبور")}
                        name="password"
                        className="login-flat-input"
                        onChange={props.handleChange}
                        onBlur={props.handleBlur}
                      />
                      <ErrorMessage name="password">
                        {(errMsg) => (
                          <div className="login-flat-error">{errMsg}</div>
                        )}
                      </ErrorMessage>
                    </div>
                    
                    {/* Checkboxes */}
                    <div className="login-flat-checkbox">
                      <input
                        onChange={() => setTermsChecked(!TermsChecked)}
                        type="checkbox"
                        className="login-flat-checkbox-input"
                        id="terms-check"
                      />
                      <label
                        className="login-flat-checkbox-label"
                         style={{ marginInlineStart: '1rem' }}
                        htmlFor="terms-check"
                        onClick={toggleTerms}
                        
                      >
                        {t("با قوانین موافقم")}
                      </label>
                    </div>
                    <div className="login-flat-checkbox">
                      <input
                        onChange={() => setPrivecyChecked(!PrivecyChecked)}
                        type="checkbox"
                        className="login-flat-checkbox-input"
                        id="privacy-check"
                      />
                      <label
                        className="login-flat-checkbox-label"
                         style={{ marginInlineStart: '1rem' }}
                        htmlFor="privacy-check"
                        onClick={togglePrivacy}
                      >
                        {t("حریم خصوصی")}
                      </label>
                    </div>
                    
                    <button
                      type="submit"
                      disabled={TermsChecked && PrivecyChecked ? false : true}
                      className="login-flat-button"
                    >
                      {t("ثبت نام")}
                    </button>
                  </Form>
                )}
              </Formik>
            </div>
          </>
        ) : (
          <Verify />
        )}
      </div>
      {showAlert.show && (
        <Alert message={showAlert.message} type={showAlert.type} />
      )}
    </div>
  );
};

const Register = withRouter(RegisterComp);

export { Register };
